import { type UseQueryResult, useQuery } from 'react-query';
import {
  FairMarketValueConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto,
} from '../../services/wealthlane-award-services';

const useGetFmvConfigurationDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto
  | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const fmvConfigurationDetails = useQuery(['getFmvConfigurationDetails'], async () => {
    return await handleRequest(
      FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationFairMarketValueConfiguration()
    );
  });

  return fmvConfigurationDetails;
};

export default useGetFmvConfigurationDetails;
